import { fetchGetJson } from '../../services/fetch-get-json'
import { attachBearerToken } from '../../services/attach-bearer-token'
import { getParam } from '../../helpers/parameters'

export const fetchPhoneApi = async (customerId, customer) => {
  const contentApiUrl = await getParam('contentApiUrl')
  return fetchGetJson(
    `${contentApiUrl}/deviceinfo?deviceRef=${encodeURIComponent(
      customerId
    )}&customer=${customer}`,
    await attachBearerToken({ method: 'GET' })
  )
}



// WEBPACK FOOTER //
// ./src/containers/Specs/services.js